import React, { useContext, useEffect, useState } from "react";
// Soft UI Dashboard PRO React example components
import { useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Pagination from "@mui/material/Pagination";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Skeleton from "@mui/material/Skeleton";
import SuiSelect from "components/SuiSelect";

import PublishIcon from "@mui/icons-material/Publish";
import EditIcon from "@mui/icons-material/Edit";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";
import PostDetailModal from "pages/de/posts/detail";
import PostCardOwner from "pages/de/posts/components/PostCardOwner";
import PostCard from "pages/de/posts/components/PostCard";

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Empty } from "antd";
import { postSortOptions } from "utils/data";
import { compare } from "utils/helper";

const FeaturedPostList = ({
  handle,
  handleRefresh,
  handleOk,
  postList = { published: [], draft: [] },
  setPostList,
  userData,
  isOwner = false,
}) => {
  const [postWorkTab, setPostWorkTab] = useState("published");
  const [myPostList, setMyPostList] = useState(postList);
  const [filteredPostList, setFilteredPostList] = useState({ published: [], draft: [] });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(4);
  const [selectedPost, setSelectedPost] = useState({});
  const [detailVisible, setDetailVisible] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [sortObj, setSortObj] = useState(postSortOptions[0]);

  const account = useContext(AccountContext);

  useEffect(() => {
    if (postList) {
      const sortStr = sortObj?.value;
      const publishedList = postList["published"]
        .map((x) => {
          x["published_at"] = x?.metadata?.published_at;
          return x;
        })
        .sort((a, b) => compare(a, b, sortStr));
      const draftList = postList["draft"].sort((a, b) => compare(a, b, sortStr));
      setMyPostList({
        published: publishedList,
        draft: draftList,
      });

      setFilteredPostList({
        published: publishedList.slice(0, pageSize),
        draft: draftList.slice(0, pageSize),
      });
    }
  }, [postList]);

  useEffect(() => {}, [sortObj]);

  const pageCount = parseInt(Math.ceil(myPostList?.[postWorkTab].length / pageSize), 10);
  const pageOptions = [];
  for (let i = 0; i < pageCount; i++) {
    pageOptions.push(i);
  }
  const entriesStart = pageSize * (page - 1) + 1;
  const entriesEnd =
    pageSize * page > myPostList[postWorkTab].length
      ? myPostList[postWorkTab].length
      : pageSize * page;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const offset = pageSize * (newPage - 1);
    const limit = pageSize;

    setFilteredPostList({
      published: myPostList.published.slice(offset, offset + limit),
      draft: myPostList.draft.slice(offset, offset + limit),
    });
  };

  const handleChangeRowsPerPage = (option) => {
    const newPageSize = parseInt(option.value, 10);
    setPageSize(newPageSize);
    setPage(1);
    const offset = 0;
    const limit = newPageSize;
    setFilteredPostList({
      published: myPostList.published.slice(offset, offset + limit),
      draft: myPostList.draft.slice(offset, offset + limit),
    });
  };

  const handleOnSortChange = (e) => {
    setSortObj(e);
    let sortStr = e?.value;
    console.log(sortStr);

    const publishedList = myPostList["published"]
      .map((x) => {
        x["published_at"] = x?.metadata?.published_at;
        return x;
      })
      .sort((a, b) => compare(a, b, sortStr));
    const draftList = myPostList["draft"].sort((a, b) => compare(a, b, sortStr));

    console.log(publishedList, draftList);

    setMyPostList({
      published: publishedList,
      draft: draftList,
    });
    setPage(0);
    const offset = 0;
    const limit = pageSize;
    setFilteredPostList({
      published: publishedList.slice(offset, offset + limit),
      draft: draftList.slice(offset, offset + limit),
    });
  };

  return (
    <SuiBox display="block" position="relative" width="100%" mx="auto">
      <SuiBox display="flex" justifyContent="space-between" alignItems="center" width="100%">
        {isOwner ? (
          <SuiBox dixplay="flex" justifyContent="flex-start" alignItems="center" gap={1}>
            <SuiButton
              sx={{ textTransform: "capitalize", p: "0px 8px", mx: 1, minHeight: 24 }}
              color="dark"
              variant={postWorkTab == "published" ? "contained" : "text"}
              fontWeight="bold"
              onClick={() => setPostWorkTab("published")}
            >
              <PublishIcon sx={{ mr: 0.5 }} />
              Published({myPostList?.["published"]?.length || 0})
            </SuiButton>
            |
            <SuiButton
              sx={{ textTransform: "capitalize", p: "0px 8px", mx: 1, minHeight: 24 }}
              color="dark"
              variant={postWorkTab == "draft" ? "contained" : "text"}
              fontWeight="bold"
              onClick={() => setPostWorkTab("draft")}
            >
              <EditIcon sx={{ mr: 0.5 }} />
              Draft({myPostList?.["draft"]?.length || 0})
            </SuiButton>
          </SuiBox>
        ) : (
          <div />
        )}

        <div style={{ backgroundColor: "white", maxWidth: 160 }}>
          <SuiSelect
            options={postSortOptions}
            onChange={handleOnSortChange}
            defaultValue={sortObj}
          />
        </div>
      </SuiBox>
      <SuiBox>
        {filteredPostList?.[postWorkTab] && filteredPostList[postWorkTab].length > 0 ? (
          <ResponsiveMasonry columnsCountBreakPoints={{ 250: 1, 650: 2, 1050: 3, 1400: 4 }}>
            <Masonry>
              {filteredPostList[postWorkTab].map((p, index) => (
                <div
                  className="mx-2 my-2"
                  style={{
                    overflow: "hidden",
                  }}
                >
                  {!isOwner ? (
                    <PostCard
                      index={index}
                      post={p}
                      sx={{ height: "auto", width: "100%" }}
                      handleClick={() => {
                        setDetailVisible(true);
                        setSelectedPost(p);
                      }}
                    />
                  ) : (
                    <PostCardOwner
                      index={index}
                      post={p}
                      imageOnly={true}
                      editable
                      sx={{ height: "auto", width: "100%" }}
                      handleRefresh={handleRefresh}
                      handleClick={() => {
                        setPreviewVisible(true);
                        setSelectedPost(p);
                      }}
                    />
                  )}
                </div>
              ))}
            </Masonry>
          </ResponsiveMasonry>
        ) : (
          <SuiBox my={4}>
            <Empty />
          </SuiBox>
        )}
      </SuiBox>
      <SuiBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={3}
      >
        <div className="flex items-center">
          <SuiBox mb={{ xs: 3, sm: 0 }}>
            <SuiTypography variant="button" color="secondary" fontWeight="regular">
              Showing {entriesStart} to {entriesEnd} of {myPostList?.[postWorkTab]?.length} entries
            </SuiTypography>
          </SuiBox>

          <SuiBox display="flex" alignItems="center" gap={1}>
            <SuiSelect
              defaultValue={{ value: pageSize, label: pageSize }}
              options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
              onChange={handleChangeRowsPerPage}
              size="small"
            />
            <SuiTypography variant="caption" color="secondary">
              entries per page
            </SuiTypography>
          </SuiBox>
        </div>
        <Pagination
          variant={"outlined"}
          color={"info"}
          count={pageOptions.length}
          defaultPage={page}
          onChange={handleChangePage}
        />
      </SuiBox>
      {detailVisible && selectedPost ? (
        <PostDetailModal
          handleClose={(postDetail) => {
            const newPostList = { ...myPostList };
            for (let i = 0; i < newPostList["published"].length; i++) {
              if (newPostList["published"][i].id == selectedPost.id) {
                newPostList["published"][i] = postDetail;
              }
            }
            for (let i = 0; i < newPostList["draft"].length; i++) {
              if (newPostList["draft"][i].id == selectedPost.id) {
                newPostList["draft"][i] = postDetail;
              }
            }
            setPostList(newPostList);
            setDetailVisible(false);
          }}
          visible={detailVisible}
          post={selectedPost}
        />
      ) : null}
      {previewVisible && selectedPost ? (
        <PostDetailModal
          handleClose={() => setPreviewVisible(false)}
          visible={previewVisible}
          post={selectedPost}
          setPost={null}
        />
      ) : null}
    </SuiBox>
  );
};

export default FeaturedPostList;
